module.exports = __webpack_public_path__ + "static/media/calculator_caramida_klinker.3a68e7a1.png";